export interface NewsItem {
  id: string;
  title: string;
  cover: string;
  summary: string;
  date: string;
  movieId: string;
  tag: string;
}

export const heroSlides: NewsItem[] = [
  {
    id: "h1",
    title: "《深空回响》口碑爆棚，硬核科幻再掀观影热潮",
    cover: "https://readdy.ai/api/search-image?query=epic%20deep%20space%20cinematic%20key%20art%2C%20spaceship%20silhouette%20against%20a%20vast%20glowing%20nebula%2C%20dark%20teal%20and%20amber%20tone%2C%20dramatic%20scale%2C%20high%20detail%20film%20banner&width=1600&height=760&seq=ht-hero-01&orientation=landscape",
    summary: "上映首周票房口碑双丰收，被观众称为年度最值得一看的国产科幻。",
    date: "2026-10-13",
    movieId: "1001",
    tag: "热映",
  },
  {
    id: "h2",
    title: "《都市浮生录》更新过半，四位主角命运走向引发热议",
    cover: "https://readdy.ai/api/search-image?query=modern%20city%20skyline%20at%20dusk%20with%20warm%20orange%20window%20lights%2C%20young%20professionals%20silhouette%2C%20cinematic%20urban%20drama%20banner%2C%20moody%20tone&width=1600&height=760&seq=ht-hero-02&orientation=landscape",
    summary: "剧集口碑持续攀升，观众期待后续剧情如何收束各条故事线。",
    date: "2026-10-13",
    movieId: "1007",
    tag: "追更",
  },
  {
    id: "h3",
    title: "《暗夜追凶》登陆流媒体，悬疑犯罪题材再成焦点",
    cover: "https://readdy.ai/api/search-image?query=rainy%20neon%20city%20street%20at%20night%2C%20lone%20figure%20walking%20under%20orange%20streetlights%2C%20crime%20thriller%20film%20banner%2C%20tense%20noir%20mood&width=1600&height=760&seq=ht-hero-03&orientation=landscape",
    summary: "港味犯罪片回归，紧凑节奏与扎实推理获得观众一致好评。",
    date: "2026-10-12",
    movieId: "1002",
    tag: "上线",
  },
  {
    id: "h4",
    title: "《蓝色星球志》4K 修复版上线，自然纪录片再受追捧",
    cover: "https://readdy.ai/api/search-image?query=majestic%20underwater%20ocean%20scene%20with%20sunlight%20rays%20and%20fish%20school%2C%20deep%20teal%20water%20with%20warm%20surface%20glow%2C%20nature%20documentary%20banner&width=1600&height=760&seq=ht-hero-04&orientation=landscape",
    summary: "超高画质重现海洋奇观，成为家庭大屏观看的热门选择。",
    date: "2026-10-11",
    movieId: "1014",
    tag: "推荐",
  },
];

export const newsList: NewsItem[] = [
  {
    id: "n1",
    title: "《迷雾之城》更新至关键节点，真相线逐渐清晰",
    cover: "https://readdy.ai/api/search-image?query=foggy%20coastal%20city%20at%20night%20with%20dim%20orange%20lamps%2C%20suspenseful%20atmosphere%2C%20cinematic%20thumbnail&width=400&height=300&seq=ht-news-01&orientation=landscape",
    summary: "最新一集揭开多年前旧案的关键线索，观众表示烧脑又过瘾。",
    date: "2026-10-13",
    movieId: "1008",
    tag: "剧集",
  },
  {
    id: "n2",
    title: "《天籁之战》半决赛舞台炸场，改编曲目登顶热搜",
    cover: "https://readdy.ai/api/search-image?query=glowing%20music%20stage%20with%20warm%20amber%20spotlights%2C%20singer%20performing%2C%20energetic%20concert%20thumbnail&width=400&height=300&seq=ht-news-02&orientation=landscape",
    summary: "嘉宾的高难度改编赢得满堂彩，相关话题持续霸榜。",
    date: "2026-10-13",
    movieId: "1011",
    tag: "综艺",
  },
  {
    id: "n3",
    title: "《山河故人记》重映定档，文艺片市场迎来暖意",
    cover: "https://readdy.ai/api/search-image?query=misty%20mountain%20range%20at%20dawn%20with%20lone%20traveler%2C%20warm%20amber%20sunrise%2C%20poetic%20cinematic%20thumbnail&width=400&height=300&seq=ht-news-03&orientation=landscape",
    summary: "口碑佳作宣布重映，为观众提供再次走进影院的机会。",
    date: "2026-10-12",
    movieId: "1003",
    tag: "电影",
  },
  {
    id: "n4",
    title: "《极速边缘》幕后特辑曝光，真实赛车拍摄令人惊叹",
    cover: "https://readdy.ai/api/search-image?query=racing%20car%20drifting%20with%20orange%20light%20trails%20at%20night%2C%20dynamic%20speed%20action%20thumbnail&width=400&height=300&seq=ht-news-04&orientation=landscape",
    summary: "剧组坚持实景拍摄，多条赛道戏份成为全片亮点。",
    date: "2026-10-12",
    movieId: "1004",
    tag: "电影",
  },
  {
    id: "n5",
    title: "《舌尖之上》推出新一季，聚焦地方风味与市井烟火",
    cover: "https://readdy.ai/api/search-image?query=steaming%20traditional%20chinese%20dishes%20on%20rustic%20wooden%20table%2C%20warm%20amber%20lighting%2C%20appetizing%20food%20thumbnail&width=400&height=300&seq=ht-news-05&orientation=landscape",
    summary: "摄制组走访多地市集，记录最真实的饮食文化。",
    date: "2026-10-11",
    movieId: "1013",
    tag: "纪录片",
  },
  {
    id: "n6",
    title: "《青春纪事》迎来收官季，校园成长故事温暖落幕",
    cover: "https://readdy.ai/api/search-image?query=students%20cycling%20on%20tree-lined%20campus%20road%20in%20warm%20afternoon%20sunlight%2C%20fresh%20nostalgic%20thumbnail&width=400&height=300&seq=ht-news-06&orientation=landscape",
    summary: "剧集以细腻的情感收束青春群像，收获大量好评。",
    date: "2026-10-10",
    movieId: "1010",
    tag: "剧集",
  },
];